// src/pages/OurCompany.jsx

import React, { useEffect, useState } from "react";
import "./OurCompany.css";
import { FaLinkedin } from "react-icons/fa";
import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

/* ──────── 1.  SENIOR-LEADER (legacy) LIST ──────────────────────────────── */
const legacy = [
  {
    name: "Nicolas He Tian Hunter",
    position: "Founder and President",
    bio: "A passionate Harvard alumnus dedicated to revolutionizing AI, global regulation, and finance.",
    linkedin: "https://www.linkedin.com/in/nicolas-hunter/",
    image: "/images/ceo.jpg",
    education: "Harvard University - Master's in System Engineering",
  },
  {
    name: "Santrupth Vedanthi",
    position: "Chief Executive Officer (CEO)",
    bio: "With a unique blend of government, technology, and business expertise, he brings a forward-thinking approach to business success.",
    linkedin: "https://www.linkedin.com/in/santrupth-vedanthi-a70b76156/",
    image: "/images/Santrupth.jpg",
    education: "California State University - MBA",
  },
    {
    name: "Ernestina Zhu",
    position: "Chief Public Relations Officer (CPRO)",
    bio: "Specialist in privacy laws and regulations, guiding our compliance strategies.",
    linkedin: "https://www.linkedin.com/in/ernestina-zhu-357228163/",
    image: "/images/pr.jpg",
    education: "University of Manchester - PhD in Blockchain and Technology",
  },
      {
    name: "Mark Stark",
    position: "Chief Finance Officer (CFO)",
    bio: "A passionate Harvard alumnus dedicated to lead the forefont of fintech and build sustanabile global government & enterprise finance systems",
    linkedin: "https://www.linkedin.com/in/markstarkii/",
    image: "/images/markstark.png",
    education: "Harvard University - Bachelor's in Economics",
  },
  {
    name: "Ragavi Muthukrishnan",
    position: "Chief AI Officer (CAIO)",
    bio: "Focused on transformative applications of AI in finance, healthcare, and law.",
    linkedin: "https://www.linkedin.com/in/ragavi-muthukrishnan-003074201/",
    image: "/images/Ragavi.jpg",
    education:
      "University at Buffalo (SUNY) - Master's in Engineering Science (Data Science)",
  },
  {
    name: "Dan Yahraes",
    position: "Chief Marketing Officer (CMO)",
    bio: "Expert in business development and global digital marketing, creating shared value for stakeholders.",
    linkedin: "https://www.linkedin.com/in/dyahraes/",
    image: "/images/daniel.jpg",
    education:
      "Montana State University-Bozeman - Bachelor's in Film/Cinema/Video Studies",
  },

  {
    name: "Beni Rincon",
    position: "Marketing Vice President (VP)",
    bio: "Expert in SaaS AI marketing, ensuring our users love what we are.",
    linkedin: "https://www.linkedin.com/in/benirincon/",
    image: "/images/cmo.jpg",
    education: "San Jose State University - Master's in Big Data",
  },
  {
    name: "Yash Amre",
    position: "Global AI and IT Senior Manager",
    bio: "Enabling scalable AI/ML systems to accelerate model deployment and drive business growth through automation and efficiency.",
    linkedin: "https://www.linkedin.com/in/yash-amre-0b84a6242/",
    image: "/images/yash.png",
    education: "University of Colorado Boulder - Master's in Big Data",
  },
  {
    name: "Yichen Hou",
    position: "Global Digital Marketing Senior Manager",
    bio: "Committed to balancing user needs and aesthetics through interaction design.",
    linkedin: "https://www.linkedin.com/in/yichen-hou/",
    image: "/images/Yichen.jpg",
    education: "Rochester Institute of Technology - Master’s in Design and Visual",
  },
  {
    name: "Helena Liu",
    position: "AI Operations - Venture Capital",
    bio: "Interdisciplinary leader in business and data science, driven to create corporate impact through quantitative analysis.",
    linkedin: "https://www.linkedin.com/in/duanyiliu/",
    image: "/images/Helena.jpg",
    education: "University of Chicago Booth - Master’s in Finance",
  },
  {
    name: "Piyush Mittal",
    position: "AI Operations - Strategy and Planning",
    bio: "Scaling business with strong foundation in operations and analytics, strategic planning, and creative problem-solving.",
    linkedin: "https://www.linkedin.com/in/piyush-mittal-6b648723b/",
    image: "/images/Piyush.png",
    education: "University of Manchester - Bachelor's in International Business",
  },
  {
    name: "Ray Chen",
    position: "AI Operations - IT and Data",
    bio: "Pushing AI technology to be as precise and accurate as it can be.",
    linkedin: "https://www.linkedin.com/in/ray-chen-a05b242b3",
    image: "/images/RayChen.jpg",
    education: "Texas A&M University - Bachelor's in Management Information Systems",
  },
  {
    name: "Rena Shrestha",
    position: "AI Operations - IT and Data",
    bio: "Passionate about leveraging data science to tell compelling stories and influence meaningful strategies.",
    linkedin: "https://www.linkedin.com/in/rena-shrestha-970352265",
    image: "/images/Rena.png",
    education: "University of California, Berkeley - Bachelor's in Data Science",
  },
  {
    name: "Maliha Eram",
    position: "AI Operations - Full Stack IT",
    bio: "Full Stack Developer skilled in React, Node.js, Express, and MongoDB.",
    linkedin: "https://www.linkedin.com/in/malihaeram/",
    image: "/images/Maliha.jpg",
    education: "Manipal University Jaipur - MBA",
  },
  {
    name: "Haitong Lyu",
    position: "AI Operations - Global Digital Marketing",
    bio: "Business Management major with a passion for managerial accounting and business analysis.",
    linkedin: "https://www.linkedin.com/in/haitong-lyu",
    image: "/images/HaitongLyu.png",
    education: "Boston University - Bachelor's in Business Administration",
  },
  {
    name: "Braden Waller",
    position: "Training and Onboarding Director",
    bio: "Creates impactful training programs that inspire growth, collaboration, and success.",
    linkedin: "https://www.linkedin.com/in/braden-waller-b353338a/",
    image: "/images/Braden.jpg",
    education: "Arizona State University - Bachelor's in Education and Training",
  },
];

/* ──────── 2.  COMPONENT ───────────────────────────────────────────────── */
export default function OurCompany() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const q = query(
      collection(db, "teamMembers"),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(q, (snap) => {
      const cloud = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const cloudByName = new Map(cloud.map((c) => [c.name.toLowerCase(), c]));
      const legacyNames = new Set(legacy.map((l) => l.name.toLowerCase()));
      const seniorSection = legacy.map(
        (l) => cloudByName.get(l.name.toLowerCase()) || l
      );
      const newcomers = cloud.filter(
        (c) => !legacyNames.has(c.name.toLowerCase())
      );
      setTeam([...seniorSection, ...newcomers]);
    });
    return () => unsub();
  }, []);

  return (
    <div className="company-container">
      {/* Banner */}
      <section className="company-banner">
        <div className="company-banner-overlay" />
        <div className="company-banner-content boxed">
          <h1 className="no-wrap">We Pioneering</h1>
        
        <h2 className="subtitle no-wrap">
           「SGI」Synthetic Generative Intelligence  
         </h2>
          <h2 className="subtitle no-wrap">
           「ASI」Artificial Superintelligence
         </h2>
                 <h2 className="subtitle no-wrap">
           「H-ONT」Human Ontology
         </h2>
      <p className="description no-wrap">
           Home of AI agents, we don’t just build tools  <br />— we build minds and virtual 5D worlds.
         </p>
          {/* 新增的 CTA 按钮组 */}
          <div className="cta-group">
              <a href="/partners" className="cta-btn">
              Our Partners
            </a>
          
            <a href="/media" className="cta-btn">
              Lex Media
            </a>
              <a href="mailto:ceo@lextrackai.com" className="cta-btn">
              Get in Touch
            </a>
          
          </div>
        </div>
      </section>

  、

      {/* Team Section */}
      <section className="team-section">
        <h2></h2>
        <div className="team-grid">
          {team.map((m) => (
            <div key={m.id || m.name} className="team-card">
              <div className="team-image" >
                <img
                  src={m.photoUrl || m.image || "/images/placeholder.jpg"}
                  alt={`${m.name}'s profile`}
                  loading="lazy"
                />
              </div>
              <div className="team-info">
                <h3>{m.name}</h3>
                <p className="team-position">{m.position}</p>
                {m.bio && <p className="team-bio">{m.bio}</p>}
                {m.education && (
                  <p className="team-education">
                    <strong>Education:</strong> {m.education}
                  </p>
                )}
                {m.linkedin && (
                  <a
                    href={m.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin-icon"
                    aria-label={`${m.name}'s LinkedIn`}
                  >
                    <FaLinkedin />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
